export default {
  // show a "notification" component popup for new notifications
  showNotificationUiNotification: true,
};
